import { ConsultModel } from "../models/Consult.model";
import { OralModel } from "../models/Oral.model"
import { PdfModel } from "../models/Pdf.model";
import http from "./http-common";

export const saveOralActive = (OralActive: OralModel) => {
    if (OralActive.id != null) {
        return http.put(`/oral-actives/${OralActive.id}`, OralActive)
    }

    return http.post('/oral-actives', OralActive)
}

export const favoriteOral = (active: number) => http.post('/oral-favorites', {active})

export const favoriteOralDelete = (active: number) => http.delete(`/oral-favorites/${active}`)

export const getAllOralActive = (admin?: boolean) => http.get('/oral-actives', { params: admin ? { admin } : {} })

export const putOral = (id: number, annotation: string) => http.put(`/oral-annotation/${id}`, {annotation})

export const saveClassification = (id: number, classifications: string[]) => http.post(`/oral-actives/${id}/user-classifications`, {classifications})

export type OralConsultationResponse =
  | { consultation: number }
  | { message: string; consultations: { patientId: number; consultationId: number }[]; totalCreated: number; totalFailed: number }

export const consultationOral = (consult: ConsultModel) => http.post<OralConsultationResponse>(`/oral-consultation`, consult)

export const deleteConsultOral = (consult: number) => http.delete(`/oral-consultation/${consult}`)

export const getConsultOral = (consult: string) => http.get(`/oral-consultation/${consult}`)

export const updateConsultOral = (id: string, consult: ConsultModel) => http.put(`/oral-consultation/${id}`, consult)

export const oralPDF = (PDF: PdfModel) => http.post(`/v2/pdf`, PDF)

export const oralHTML = (PDF: PdfModel) => http.post(`/v2/pdf/html`, PDF)

export const getOralActive = (id: number) => http.get(`/oral-actives/${id}`)

// region Batch Oral Consultation V2

export interface OralActiveData {
    active: number
    volume: number
    unit: string
}

export interface OralConsultationData {
    name: string
    actives: OralActiveData[]
    observations?: string[]
}

export interface BatchOralConsultationRequest {
    patients: number[]
    consultation: OralConsultationData
}

export interface BatchOralConsultationResult {
    patientId: number
    consultationId?: number
    error?: string
}

export interface BatchOralConsultationSummary {
    total: number
    created: number
    failed: number
}

export interface BatchOralConsultationResponse {
    message: string
    results: BatchOralConsultationResult[]
    summary: BatchOralConsultationSummary
}

export const createBatchOralConsultation = (request: BatchOralConsultationRequest) => {
    return http.post<BatchOralConsultationResponse>('/v2/oral-consultation/batch', request)
}

export const consultModelToBatchRequest = (
    consult: ConsultModel,
    patients: number[]
): BatchOralConsultationRequest => {
    return {
        patients,
        consultation: {
            name: consult.name || '',
            actives: consult.actives.map((active: any) => ({
                active: active.active || active.id,
                volume: active.volume || 0,
                unit: active.unit || active.unity || '',
            })),
            observations: consult.observations,
        }
    }
}

// endregion